import { Users } from 'lucide-react'

export function CreatorRepository() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-20 h-20 rounded-2xl bg-blue-50 flex items-center justify-center mb-6">
        <Users className="w-10 h-10 text-blue-500" />
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2">Creators</h1>
      <p className="text-4xl font-bold text-gray-900 mb-3">Coming Soon</p>
      <p className="text-gray-500 max-w-sm leading-relaxed">
        We&apos;re building a powerful creator discovery and management hub. Stay tuned for sourcing, evaluation, and partnership tracking — all in one place.
      </p>

      <div className="mt-8 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.3s]" />
        <span className="w-2 h-2 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.15s]" />
        <span className="w-2 h-2 rounded-full bg-blue-500 animate-bounce" />
      </div>
    </div>
  )
}
